/* eslint-disable */

const enUs = {
    'play-store': 'Download Play Store',
    'app-store': 'Download App Store',
}

export default enUs